import { useTranslation } from "react-i18next";

import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "~/components/ui";
import { usePropertyTypes } from "~/features/admin/propertySchemas/hooks";

const NONE = "__none";

interface PropertyTypeSelectProps {
  value: string;
  onChange: (value: string) => void;
  supportedTypes?: readonly string[];
  disabled?: boolean;
}

/** Property-type dropdown backed by `GetPropertyTypesDocument`. Includes a "none" item that maps to an empty string. */
export function PropertyTypeSelect({
  value,
  onChange,
  supportedTypes = [],
  disabled = false,
}: PropertyTypeSelectProps) {
  const { t } = useTranslation();
  const propertyTypes = usePropertyTypes();

  return (
    <Select value={value ? value : NONE} onValueChange={(v) => onChange(v === NONE ? "" : v)} disabled={disabled}>
      <SelectTrigger className="h-9 w-[200px]" aria-label={t("model.propertySchema.propertyTypeId")}>
        <SelectValue placeholder={t("model.propertySchema.propertyTypeId")} />
      </SelectTrigger>
      <SelectContent>
        <SelectItem value={NONE}>
          <em className="text-fg-3">{t("ui.none")}</em>
        </SelectItem>
        {propertyTypes
          .filter((type) => supportedTypes.length === 0 || supportedTypes.includes(type.id))
          .map((type) => (
            <SelectItem key={type.id} value={type.id}>
              {type.id}
            </SelectItem>
          ))}
      </SelectContent>
    </Select>
  );
}
